/* !!!!!!!!!!!!!!!!!!!!!! */
/* !!! GENERATED FILE !!! */
/* !!!!!!!!!!!!!!!!!!!!!! */

import {
  ModuleDoneType,
  ModuleType,
  PlaniraPlanImage,
  type PlaniraTemplate,
} from "../../types";
import { PlanType } from "../../types";
import { PlanTemplateType } from "../template_types";

export const FlowIceCreamSocialTemplate: PlaniraTemplate = {
  type: PlanTemplateType.FlowIceCreamSocial,

  planType: PlanType.Quickstart,
  suggestedTitles: [
    "Cool Down with Ice Cream!",
    "Let’s Scoop and Share!",
    "Ice Cream Lovers Unite!",
  ],
  title: "Ice Cream Social",
  description: "Organize a delightful ice cream social.",
  longDescription:
    "Gather your friends for a fun ice cream social! Choose a date, decide on flavors, and plan toppings to enjoy together!",
  emoji: "🍦",
  titleHelp: "Change title or choose another:",
  imageType: PlaniraPlanImage.Party,

  sections: [
    {
      section: {
        isExpandable: false,
        isDraggable: false,
      },
      modules: [
        {
          type: ModuleType.PlanInfo,
          doneType: ModuleDoneType.None,
          title: "Ice Cream Social",
          emoji: "🍦",
        },
      ],
    },
    {
      section: {
        title: "Ongoing",
      },
      modules: [
        {
          type: ModuleType.Calendar,
          doneType: ModuleDoneType.Voting,
          title: "When should we have the ice cream social?",
          emoji: "📅",
          completeAction: {
            question: "Decide on flavors to serve?",
            description: "What ice cream flavors should we offer?",
            addModules: [
              {
                type: ModuleType.Poll,
                doneType: ModuleDoneType.Voting,
                title: "What flavors should we include?",
                emoji: "🍨",
                completeAction: {
                  question: "Decide on toppings?",
                  description:
                    "What toppings should we have for the ice cream?",
                  addModules: [
                    {
                      type: ModuleType.Poll,
                      doneType: ModuleDoneType.Voting,
                      title: "What toppings should we bring?",
                      emoji: "🍫",
                    },
                  ],
                },
              },
            ],
          },
        },
      ],
    },
  ],

  onTemplateComplete: {
    outroTitle: "Let’s Enjoy Some Ice Cream!",
    outroDescription:
      "Your ice cream social plans are set! Enjoy the sweet treats!",
  },
};
